<template>
  <div class="progress-bar">
    <div
      class="progress"
      :style="{ width: value + '%' }"
    ></div>
    <img :style="{ left: value + '%' }" class="progress-logo" src="@/assets/style/progress-logo.png" alt="">
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    value: {
      type: [String,Number],
      default: "0", // 最大宽度，单位px
    },
    maxWidth: {
      type: Number,
      default: 100, // 最大宽度，单位px
    },
    color: {
      type: String,
      default: "", // 进度条颜色
    },
    linearGradient: {
      type: String,
      default: "#1d70f7", // 进度条颜色
    },
  },
};
</script>

<style scoped lang="scss">
.progress-bar {
  height: 6px; /* 根据需要调整 */
  width: 100%;
  background: #ccdcf7;
  position: relative;
  border-radius: 6px;
}
.progress-logo {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 22px;
}
.progress {
  height: 100%; /* 与父容器相同高度 */
  border-radius: inherit; /* 继承父容器的边框半径 */
  background: #1d70f7;
}
</style>
